/* anillo-cobre-cart.js — añadir al carrito para todos los CTA de la página clonada */
(function () {
  if (window.__acmCartInit) return;
  window.__acmCartInit = true;

  function selectedVariantId(btn) {
    var radio = document.querySelector('input[name="acm-offer"]:checked');
    if (radio && radio.value) return radio.value;
    return btn.getAttribute('data-variant-id');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-acm-cta]') : null;
    if (!btn) return;
    e.preventDefault();

    var id = selectedVariantId(btn);
    if (!id) { window.location.href = '/cart'; return; }

    btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add-to-cart failed'); return r.json(); })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function () { btn.classList.remove('is-loading'); window.location.href = '/cart'; });
  });
})();
